export const page = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  backgroundColor: "#F3F6FD",
  fontFamily: "'DM Sans', sans-serif",
};

export const header = {
  backgroundColor: "#0D1F4D",
  color: "white",
  padding: "16px 24px",
  display: "flex",
  justifyContent: "space-between",
  fontWeight: 700,
  
  position: "sticky",
  top: 0,
  zIndex: 1000
};

export const container = {
  width: "100%",
  maxWidth: "900px",
  margin: "40px auto",
  boxSizing: "border-box",
};

export const topBar = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
};

export const title = {
  margin: 0,
  color: "#0D1F4D",
};

export const clientCard = {
  background: "white",
  borderRadius: "14px",
  padding: "16px",
  marginBottom: "14px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
};

export const clientRow = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

export const expand = {
  cursor: "pointer",
  fontSize: "20px",
  fontWeight: 700,
  color: "#8CA5E6",
};

export const clientName = {
  fontWeight: 600,
  color: "#0D1F4D",
};

export const clientEmail = {
  fontSize: "14px",
  color: "#555",
};

export const actions = {
  display: "flex",
  gap: "8px",
};

export const detailsCard = {
  backgroundColor: "#F3F6FD",
  borderRadius: "12px",
  marginTop: "16px",
  padding: "12px",
};

export const detailsHeader = {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  fontWeight: 600,
  color: "#0D1F4D",
  fontSize: "14px",
  position: "sticky",
  top: 0,
  background: "white",
  paddingTop: "10px",
  paddingBottom: "8px",
  borderBottom: "1px solid #E6ECF8",
  zIndex: 1,
};

export const detailRow = {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  padding: "6px 0",
  fontSize: "14px",
  borderBottom: "1px solid #E6ECF8",
};

export const primaryBtn = {
  backgroundColor: "#0D1F4D",
  color: "white",
  border: "none",
  borderRadius: "8px",
  padding: "10px 16px",
  fontWeight: 600,
};

export const primaryBtnSmall = {
  ...primaryBtn,
  padding: "6px 12px",
};

export const secondaryBtn = {
  backgroundColor: "#8CA5E6",
  color: "white",
  border: "none",
  borderRadius: "8px",
  padding: "6px 12px",
  fontWeight: 600,
};
